import * as React from "react";
import * as Immutable from "immutable";
import { ReadOnlyFormGroup } from "components/common";
import { Alert } from "components/bootstrap";
import LicenseCheck from "../../../license/LicenseCheck";
const getRolesList = (roles, defaultRolesIds) => {
  if (!defaultRolesIds || defaultRolesIds.size === 0) {
    return null;
  }
  const defaultRolesNames = defaultRolesIds.map((roleId) => {
    var _a;
    return (_a = roles.find((role) => role.id === roleId)) == null ? void 0 : _a.name;
  });
  return defaultRolesNames.join(", ");
};
const _readableSelectionType = (selectionType) => {
  switch (selectionType) {
    case "all":
      return "All matching groups";
    case "include":
      return "Include selected groups";
    case "exclude":
      return "Exclude selected groups";
    default:
      return selectionType;
  }
};
const GroupSyncDetails = ({ groupSyncBackend, roles, excludedFields = {} }) => {
  if (!groupSyncBackend) {
    return /* @__PURE__ */ React.createElement(Alert, null, "Group synchronization not configured for this authentication service.");
  }
  const {
    defaultRoles,
    selectionType,
    selection = Immutable.Set(),
    config: { groupSearchBase, groupSearchPattern, teamNameAttribute, teamUniqueIdAttribute }
  } = groupSyncBackend;
  const rolesList = defaultRoles && defaultRoles.size >= 1 ? getRolesList(roles, defaultRoles) : null;
  return /* @__PURE__ */ React.createElement(LicenseCheck, null, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Group Search Base DN", value: groupSearchBase }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Group Search Pattern", value: groupSearchPattern }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Team Name Attribute", value: teamNameAttribute }), !excludedFields.teamUniqueIdAttribute && /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Team Id Attribute", value: teamUniqueIdAttribute }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Team Default Roles", value: rolesList }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Selection Type", value: _readableSelectionType(selectionType) }), selectionType !== "all" && /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Selected Groups", value: `${selection.size} group(s)` }));
};
export default GroupSyncDetails;
